var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeople(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#fff",
    r: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.7716 9.2168c-3.16742 0-5.77157 2.1663-5.77157 4.8293 0 1.0644.41512 2.1462 1.17641 2.9847l-1.07504 1.2218c-.10578.1204-.13143.2913-.0645.4372.06653.1458.21238.2395.37344.2395h5.77156c2.3386 0 5.3612-2.0029 5.3612-4.8832 0-2.663-2.6041-4.8293-5.7715-4.8293zm-2.48917 5.5773c-.45238 0-.8206-.3663-.8206-.8162s.36824-.8162.8206-.8162c.45235 0 .82059.3663.82059.8162.00003.4499-.36821.8162-.82059.8162zm2.48917 0c-.4524 0-.82061-.3663-.82061-.8162s.36821-.8162.82061-.8162c.4523 0 .8206.3663.8206.8162s-.3682.8162-.8206.8162zm2.4891 0c-.4523 0-.8205-.3663-.8205-.8162s.3682-.8162.8205-.8162c.4524 0 .8206.3663.8206.8162s-.3682.8162-.8206.8162z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.9054 13.3039-.9661-1.121c.6896-.7739 1.0651-1.7176 1.0651-2.694-.0001-2.47518-2.3929-4.4889-5.3339-4.4889-2.6595 0-4.919 1.64839-5.31796 3.7939.74206-.25079 1.57425-.39335 2.41846-.39335 3.593 0 6.545 2.49605 6.5882 5.57725h1.2349c.3505 0 .5387-.4105.3113-.6739z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.f5127bccfd363308dd1a82bf38715a2c.svg";
export { ForwardRef as ReactComponent };